import { createContext, useContext } from 'react'

import type { Me } from '@/api/types'

export const MeContext = createContext<Me | null>(null)

/** The signed-in FPA user (`GET /v1/me`). Available below <AccessGate>. */
export function useMe(): Me {
  const me = useContext(MeContext)
  if (!me) throw new Error('useMe must be used inside <AccessGate>')
  return me
}
